module.exports = __webpack_public_path__ + "static/media/jieqiabiaozhun62.1cb38dfe.png";